export default "__VITE_ASSET__B9vIT8il__"